import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';

@Injectable({ providedIn: 'root' })
export class NativeAppService {
  openWebView = async (url: string) => {
    await Browser.open({ url: url, presentationStyle: 'popover' });
  };

  closeWebView = async () => {
    await Browser.close();
  };
}
